import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-stretchable-text',
  templateUrl: './stretchable-text.component.html',
  styleUrls: ['./stretchable-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StretchableTextComponent implements AfterViewInit {
  @Input() initialFontSize = 80;
  @ViewChild('textContainer') textContainer: ElementRef<HTMLElement> =
    {} as ElementRef;

  ngAfterViewInit() {
    this.adjustFontSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.adjustFontSize();
  }

  constructor(private hostEl: ElementRef) {}

  frameId?: number;
  adjustFontSize() {
    if (this.frameId) {
      cancelAnimationFrame(this.frameId);
      this.frameId = undefined;
    }
    const containerHeight = this.hostEl.nativeElement.clientHeight;
    const textHeight = this.textContainer.nativeElement.clientHeight;
    const containerWidth = this.hostEl.nativeElement.clientWidth;
    const textWidth = this.textContainer.nativeElement.clientWidth;

    if (textHeight < containerHeight && textWidth <= containerWidth) {
      this.initialFontSize = this.initialFontSize * 1.01;
      this.textContainer.nativeElement.style.setProperty('--font-size', `${this.initialFontSize}px`);
      this.frameId = requestAnimationFrame(() => this.adjustFontSize());
      return;
    }
    if (textHeight > containerHeight || textWidth > containerWidth) {
      this.decrease();
      return;
    }
  }
  decrease() {
    if (this.frameId) {
      cancelAnimationFrame(this.frameId);
      this.frameId = undefined;
    }
    const containerHeight = this.hostEl.nativeElement.clientHeight;
    const textHeight = this.textContainer.nativeElement.clientHeight;
    const containerWidth = this.hostEl.nativeElement.clientWidth;
    const textWidth = this.textContainer.nativeElement.clientWidth;


    if (textHeight > containerHeight || textWidth > containerWidth) {
      this.initialFontSize = this.initialFontSize * 0.99;
      this.textContainer.nativeElement.style.setProperty('--font-size', `${this.initialFontSize}px`);
      this.frameId = requestAnimationFrame(() => this.decrease());
      return;
    }
  }
}
